export default "__VITE_ASSET__L2wnf04C__"